import { Component, OnInit, PLATFORM_ID, Inject, Renderer2, HostListener, ElementRef } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { FormGroup } from '@angular/forms';
import { WebsiteService } from 'src/app/_services/website.service';
import { LinkService } from '../../_services/langhfre.service';
import { ActivatedRoute } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
import { NavigationService } from 'src/app/_services/navigation.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
  isYearlyChecked: boolean = true;
  formSection: boolean = true;
  thankSection: boolean = false;
  contactForm: FormGroup;
  disabledSubmitButton: boolean = true;
  contactUsSection: String;
  monthfinalSection: boolean = false;
  YearlyfinalSection: boolean = true;
  country: string;
  encodedData: any;
  decodedData: any;
  paymentModeOption: any;
  finalAmmount: any;
  isSticky = false;
  isSubmitting: boolean = false;
  activeTab: string = 'individuals';
  Math = Math; 

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private route: ActivatedRoute,
    public paymentService: WebsiteService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private el: ElementRef, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    public loadScript: LoadScriptService,
    public navigationService: NavigationService
  ) {
    
    this.document.body.classList.add('nosnipptFooter');
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem("country-trinka")) {
        this.fetchPlans();
      } else {
        this.loadGeoAPIScript();
      }
    }
    this.titleService.setTitle('AI搭載英文校正ツールTrinkaの料金プラン | Trinka');
    this.metaTagService.updateTag({ name: 'description', content: 'AI搭載英文校正ツールTrinkaでは、無料のベーシックプランと月払い／年払いから選べる有料プレミアムプランの2つの料金プランをご用意しています。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '英文校正 無料,無料文法チェック,テクニカルライティング,アカデミックライティング,英文チェッカー,校正ツール,AI校正ツール,AIツール,学術論文,文法チェック,文法チェックツール,英文校正 サイト,英文チェック サイト,Trinka,トリンカ' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'AI搭載英文校正ツールTrinkaの料金プラン | Trinka' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'AI搭載英文校正ツールTrinkaでは、無料のベーシックプランと月払い／年払いから選べる有料プレミアムプランの2つの料金プランをご用意しています。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/pricing' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'AI搭載英文校正ツールTrinkaの料金プラン | Trinka' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "AI搭載英文校正ツールTrinkaでは、無料のベーシックプランと月払い／年払いから選べる有料プレミアムプランの2つの料金プランをご用意しています。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/pricing' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/pricing' });
    
    this.activeTab = 'individuals'; // Set the default tab immediately

    this.route.fragment.subscribe((fragment: string | null) => {
      this.activeTab = fragment ? fragment.toLowerCase() : 'individuals';
      this.setTab(this.activeTab);
    });

    this.currentTestimonials = this.individuals;
  }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      const scriptName = "geoIP";
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          
          // Use arrow functions to maintain the context of 'this'
          const onSuccess = (location) => {
            localStorage.setItem("country-trinka", location['country']['iso_code']);
            this.fetchPlans();
          };
  
          const onError = (error) => {
            console.error('GeoIP error:', error);
            localStorage.setItem("country-trinka", "IN");
            this.fetchPlans();
          };
  
          try {
            // @ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.error('GeoIP catch error:', error);
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }
  

  fetchPlans() {
    this.country = localStorage.getItem("country-trinka") || "en";
    this.route.params.subscribe(params => {
      this.encodedData = params['id'];
      this.paymentService.getPlans(this.encodedData, 1).subscribe(resp => {
        if (resp['message'] === 'success') {
          this.decodedData = resp['data'];
          this.decodedData.sort((a, b) => a.index - b.index);
          this.paymentModeOption = this.decodedData;
          console.log("Country is: ", this.country);
          const annualAmount = this.decodedData[3].final_amount;
          this.finalAmmount = annualAmount / 12;
        }
      });
    });
  }
  
  monthyPricing() {
    this.monthfinalSection = true;
    this.YearlyfinalSection = false;
  }
  yearlyPricing() {
    this.monthfinalSection = false;
    this.YearlyfinalSection = true;
  }
  //   scroll(el: HTMLElement) {
  //     el.scrollIntoView();
  // }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      //document.getElementById('main_header').classList.remove('pricingPageHeader');
      this.document.body.classList.remove('nosnipptFooter');
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const element = this.el.nativeElement.querySelector('.table-container');
    const rect = element.getBoundingClientRect();

    if (rect.top <= 0) {
      // Add your CSS class when the element touches the top of the page
      this.renderer.addClass(element, 'sticky-class');
    } else {
      // Remove the CSS class when the element is not touching the top of the page
      this.renderer.removeClass(element, 'sticky-class');
    }
  }

  calculateIntegerPart(amount: number): number {
    return Math.floor(amount);
  }
  
  calculateFractionalPart(amount: number): string {
    const fractional = amount - Math.floor(amount);
    return fractional.toFixed(2).substring(1);
  }

  getOriginalPrice(finalAmount: number): number {
    if (!finalAmount) return 0;
  
    return finalAmount / 0.3333;
  }

  ngAfterViewInit(): void {
    // Set the initial active tab on page load
    const section = document.querySelector('.choosePlan') as HTMLElement;
    const tabs = document.querySelector('.pricingTabs') as HTMLElement;
  
    window.addEventListener('scroll', () => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const scrollY = window.scrollY;
      const tabsHeight = tabs.offsetHeight;
  
      if (scrollY > sectionTop - 70 && scrollY < sectionTop + sectionHeight - tabsHeight - 70) {
        tabs.classList.add('sticky-active');
        tabs.classList.remove('sticky-end');
      } 
      else if (scrollY >= sectionTop + sectionHeight - tabsHeight - 70) {
        tabs.classList.remove('sticky-active');
        tabs.classList.add('sticky-end');
      } 
      else {
        tabs.classList.remove('sticky-active');
        tabs.classList.remove('sticky-end');
      }
    });
  }

  

  customLogos = [
    { src: '../../../../assets/images/plagiarism-check/clients/mit.svg', width: 62, height: 33, alt: 'mit', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/IEEE.svg', width: 110, height: 32, alt: 'IEEE', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/stanford.svg', width: 99, height: 44, alt: 'stanford', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/wiley.svg', width: 114, height: 28, alt: 'wiley', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/pfizer.svg', width: 118, height: 48, alt: 'pfizer', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/abbott.svg', width: 126, height: 32, alt: 'abbott', class: '' },
    { src: '../../../../assets/images/plagiarism-check/clients/princeton.svg', width: 132, height: 36, alt: 'princeton', class: '' }

  ];

  currentTestimonials: any[] = [];

  setTab(tab: string) {
    if (tab === 'individuals') {
      this.currentTestimonials = this.individuals;
    }
  
    if (tab === 'enterprise') {
      this.currentTestimonials = this.enterprise;
    }
  
    if (tab === 'institution') {
      this.currentTestimonials = this.institution;
    }
  
    setTimeout(() => {
      const carousel = (window as any).$('#individualSlider');
      if (carousel) {
        carousel.carousel(0);
      }
    }, 50);
  }

  individuals = [
    {
      "author": "ウーゴ・アルベルト・リヴェラ・ロドリゲス 様",
      "designation": "コロンビア ロサリオ大学助教授",
      "message": "Trinkaで出版した論文を改善できました。また改訂に加え、私の研究に沿ったジャーナルの提案もしてくれました。",
      "photo": "clientPhotos/hugo.jpg"
    },
    {
      "author": "ミハル・プラチェク 様",
      "designation": "チェコ共和国 カレル大学公共・社会政策学部教授",
      "message": "Trinkaで研究作業が大幅に効率化できました。英語が母語でない私は、論文を仕上げる前に英文校正サービスを利用してきましたが、これには時間も、多額の費用もかかりました。Trinkaのおかげで、研究そのものに多くの時間を費やすことができます。",
      "photo": "clientPhotos/michal.jpg"
    },
    {
      "author": "大阪大学大学院",
      "designation": "イケレ・チニエレ・メアリー＝シンシア 様",
      "message": "Trinkaを初めて利用したのは、論文の文法や句読点の誤りをチェックするためでした。迅速で正確な修正提案と、初回ユーザーに提供される無料クレジットの使いやすさに満足しました。また、Trinkaでは学術論文執筆のための活用法に関するワークショップを開催しており、そこから大いに学びを得ることができました。",
      "photo": "clientPhotos/Mary-Cynthia.webp"
    },
  ]

  enterprise = [
    {
      "author": "テオ・ファン・レーウェン 様",
      "designation": "インドネシア Rio Tinto Exploration SE Asiaマネージャー ",
      "message": "インドネシア Rio Tinto Exploration SE Asiaマネージャー この数年、Trinkaを使って、自分の学術的な文章（地質学）をチェックしています。他にいくつかのプログラムを試しましたが、その中でTrinkaは最高でした。質問に対して答えてくれるサービスも素晴らしいです。",
      "photo": "clientPhotos/theo-van-leeuwen.jpg"
    },
    {
      "author": "ドミトリー・ベロウソフ 様",
      "designation": "ロシア OKI出版マネージングエディター",
      "message": "Trinkaを使い始めて数年ですが、とても良い印象を持っています。文章の質を向上させるのに本当に役立つツールです。特に気に入ったのは文法とスタイルのチェッカーで、細かい誤りを見つけるだけでなく、適切な修正を提案してくれます。直感的なプログラムのインターフェイスで、初めてのユーザーでも使いやすいです。出版関係者にとっては多目的に使えるツールで、ライティングスキルを向上させたいすべての人にお勧めします。",
      "photo": "clientPhotos/dmitry-belousov.png"
    },
  ]

  institution = [
    {
      "author": "トルコ イブン・ハルドゥーン大学法学部 助教",
      "designation": "オマール・ファルーク＝カファリ 様",
      "message": "法学の助教として私が学術論文の執筆で最も大切にしているのは、正確さと明瞭さです。Trinkaは、私の原稿執筆ワークフローにおいて欠かせないツールになりました。ツールが持つ高精度の文法・スタイルチェック機能と正式な法学英語に対する理解力で、法学の学術的議論に求められる高い水準を維持することができます。Trinkaは、複雑な論点を洗練させ明瞭な形で論証を提示するのに役立ちます。校正作業にかかる時間の節約にもつながっています。",
      "photo": "clientPhotos/omer-faruk.webp"
    },
    {
      "author": "ヨハネスブルグ大学",
      "designation": "研究・イノベーション担当 経営幹部グループメンバー <br/>図書館・情報センター 執行理事（代行）<br/>ンケンソ・シブイ博士    ",
      "message": "Trinkaを導入して3年目ですが、これにより図書館・情報センターの論文執筆支援の取り組みにポジティブな成果をもたらしました。導入当初の目標は、学生や研究者に、論文の質を高めるためのリソースを提供することでした。以降、このプラットフォームは、文章の推敲や出版準備など、研究論文の執筆プロセスのさまざまな側面に役立ってきました。Trinkaとの提携は、本学における研究支援サービス強化に向けた、当センターの幅広い取り組みの一環をなしています。",
      "photo": "clientPhotos/nkhenso.webp"
    },
    {
      "author": "ジジガ大学 - 上級講師兼人事管理部長",
      "designation": "アブディ・ユスフ氏",
      "message": "この1年間、Trinkaを利用していますが、おかげで執筆プロセスが大幅に改善されました。文法や文章スタイルに関する高度な提案のおかげで、洗練された専門的な文章に仕上げられるようになりました。Trinkaは単なるツールではなく、文章の質を高めたいと考えるすべての人にとって欠かせないパートナーです。文章の明瞭さと正確さを重視するすべての方に、強くお勧めします。",
      "photo": "clientPhotos/abdi-yusuf.jpg"
    },
  ]

  
}
